import { ItemPageInfoBannerModel } from '@marketplace-web/item-page/item-page-data'

export const getItemPageInfoBannerPluginModel = (
  data: ItemPageInfoBannerModel,
): ItemPageInfoBannerModel => ({
  title: data.title ?? undefined,
  body: data.body ?? undefined,
  level: data.level,
  item_id: data.item_id,
})
